import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { resetBodyScrollLock } from './components/useBodyScrollLock.js';
import './index.css';

// Страница всегда стартует с рабочей прокруткой, даже если предыдущая
// отрисовка оборвалась при открытом модальном окне.
resetBodyScrollLock();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /**
       * Справочники не перезапрашиваются при возврате во вкладку.
       *
       * Иначе фоновое обновление затёрло бы черновик пользователя: он ушёл
       * пообедать с несохранёнными правками в разделе «Клиники», вернулся —
       * и правки исчезли. Обновление данных происходит явно: после сохранения
       * или по кнопке.
       */
      refetchOnWindowFocus: false,
      /**
       * А вот при ВОЗВРАЩЕНИИ СВЯЗИ запрос повторяется.
       *
       * Это другой случай, чем возврат во вкладку. Там данные на экране
       * настоящие, и трогать их незачем; здесь запрос уже провалился, и на
       * экране либо сообщение об ошибке, либо цифры, устаревшие с момента
       * обрыва. Раньше стояло `false`, и связь могла вернуться, а раздел
       * оставался мёртвым до перезагрузки страницы — на телефоне, где сеть
       * пропадает в лифте и в подвале, это происходило постоянно.
       *
       * Черновику это не грозит: перенос свежих данных в правки делает
       * `useSync`, а он ничего не трогает, пока в разделе есть несохранённое.
       */
      refetchOnReconnect: true,
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
